import React from 'react';
import config from './configs';

import './LinkLoader.scss';

function LinkLoader() {
  const { animationLoader: { gif } } = config;

  if (!gif) {
    return null;
  }

  return (
    <div className="mn_instoreAnimationGifWrap">
      <img className="mn_instoreAnimationGif" src={gif} alt="Icon loading" />
    </div>
  );
}

export default LinkLoader;
